// Central brand config — change these values to rebrand the entire product.
export const BRAND = {
  name: "EquiWelt",
  shortName: "EW",
  tagline: "Equestrian Community & International Careers",
  workingNameNote: "Verified equestrian professionals · guided international hiring.",
};

export const POSITIONING = "Equestrian Community & International Careers";
export const HERO_LINE = "Where Equestrian Talent Meets Global Opportunity.";
export const JOIN_CTA = "Join the Equestrian Community.";

export const COLORS = {
  forest: "#1F4A38",
  forestDeep: "#173A2C",
  gold: "#C4A46B",
  ivory: "#FDFBF7",
  surface: "#FFFFFF",
  text: "#2C2A29",
  muted: "#5C5855",
  border: "#E8E4DB",
  approved: "#2E6B4B",
  review: "#D28E3D",
  withdrawn: "#8B3A3A",
};

export const CATEGORIES = [
  "Horse Life",
  "Fairs & Events",
  "Horse News",
  "Incidents & Safety",
  "Best Practices",
  "Learning",
  "Jobs",
];

// Equestrian professions with role-specific skills. Extensible — add more here.
export const PROFESSIONS = [
  { id: "groomer", label: "Groomer", skills: ["Clipping", "Plaiting/Braiding", "Tacking up", "Mucking out", "Bandaging", "Turnout & rugs", "Foaling care", "Show prep"] },
  { id: "rider", label: "Rider", skills: ["Dressage", "Show jumping", "Eventing", "Flatwork/Schooling", "Hacking", "Young horse producing"] },
  { id: "jockey", label: "Jockey", skills: ["Flat racing", "National Hunt", "Track work / Riding out", "Weight management", "Race tactics"] },
  { id: "farrier", label: "Farrier", skills: ["Hot shoeing", "Cold shoeing", "Trimming", "Remedial / Corrective shoeing", "Forging"] },
  { id: "trainer", label: "Trainer", skills: ["Yard management", "Schooling programmes", "Fitness / Conditioning", "Client liaison", "Competition planning"] },
];
